{
  "Clear search": "Vymazat hledání"
}
